export default __webpack_public_path__ + "static/ground-12dfc4899e0084417f10d1042bf0197b.webp";